import React from "react";
import { BibleVerseComp } from "../../components/bibleverse/bibleversecomp";

const BibleVerse = () => {

    return(

        <>
            <BibleVerseComp />
        </>
    )
}

export default BibleVerse